import { Injectable } from '@angular/core';
import { BaseService } from '../core/components/base.service';
import { Http, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { RequestUtil } from '../util/request.util';
import {MessageService} from 'primeng/components/common/messageservice';
@Injectable()
export class UsersService extends BaseService<any>{

  private static USER_RESOURCE: string = "/users";
  private static USER_AUTHENTICATE_RESOURCE: string = UsersService.USER_RESOURCE + "/authenticate";

  constructor(protected http: Http,protected messageService: MessageService) {
    super(http,messageService);
  }

  public authenticate(username: string, password: string, onSuccess) {
    let headers = RequestUtil.createHeaders(BaseService.CONTENT_TYPE_FORM,false);
    let params: URLSearchParams = RequestUtil.createURLSearchParams();
    params.set("username", username);
    params.set("password", password);
    let options = new RequestOptions({ headers: headers });
    this.post(BaseService.URL_BASE + UsersService.USER_AUTHENTICATE_RESOURCE, params, options, onSuccess);
  }

}



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/services/users.service.ts